import React from 'react';

import clsx from 'clsx';
import { Box, ButtonBase, makeStyles, Theme, createStyles } from '@material-ui/core';

import { notificationBadge } from '@vyce/core/src/theme/styles';

import { unreadLabel } from './chatListTime';

export interface ChatFolder {
  key: string;
  label: string;
  // Unread chats in it, shown beside the label.
  unread?: number;
}

interface Props {
  folders: ChatFolder[];
  value: string;
  onChange: (key: string) => void;
  disabled?: boolean;
}

// Telegram's folder tabs over a chat list: All, Unread, Groups…
export const ChatFolders: React.FC<Props> = ({ folders, value, onChange, disabled }) => {
  const classes = useStyles();

  return (
    <Box className={classes.root} role="tablist" aria-label="Chat folders">
      {folders.map(folder => {
        const active = folder.key === value;
        return (
          <ButtonBase
            key={folder.key}
            role="tab"
            aria-selected={active}
            disabled={disabled}
            onClick={() => onChange(folder.key)}
            className={clsx(classes.tab, { [classes.active]: active })}
          >
            {folder.label}
            {!!folder.unread && <span className={classes.count}>{unreadLabel(folder.unread)}</span>}
          </ButtonBase>
        );
      })}
    </Box>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      gap: 4,
      overflowX: 'auto',
      scrollbarWidth: 'none',
      '&::-webkit-scrollbar': { display: 'none' },
    },
    tab: {
      flex: 'none',
      height: 32,
      gap: 6,
      padding: '0 12px',
      borderRadius: 16,
      fontSize: 14,
      fontWeight: 500,
      color: theme.palette.text.secondary,
      transition: 'background-color 150ms, color 150ms',
      '&:hover': { backgroundColor: theme.palette.action.hover },
    },
    active: {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.action.selected,
      fontWeight: 600,
      '&:hover': { backgroundColor: theme.palette.action.selected },
    },
    count: {
      minWidth: 18,
      height: 18,
      padding: '0 5px',
      borderRadius: 9,
      fontSize: 11,
      fontWeight: 600,
      lineHeight: '18px',
      backgroundColor: notificationBadge.background,
      color: notificationBadge.text,
    },
  })
);
